export default __webpack_public_path__ + "fa9b1321f9b44b2d68bfb682a4ca6167.svg";